import { render, staticRenderFns } from "./Deleted.vue?vue&type=template&id=c9c51434&"
import script from "./Deleted.vue?vue&type=script&lang=js&"
export * from "./Deleted.vue?vue&type=script&lang=js&"
import style0 from "./Deleted.vue?vue&type=style&index=0&id=c9c51434&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports